var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "carats-table" },
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-modal",
              rawName: "v-b-modal.modal-1",
              modifiers: { "modal-1": true }
            }
          ],
          staticClass: "carats-table-btn"
        },
        [_vm._v(_vm._s(_vm.$t("carats-table.btn")))]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            size: "lg",
            "modal-class": "carats-table-modal",
            title: _vm.currentJewelSelection.name,
            id: "modal-1",
            centered: ""
          },
          on: { show: _vm.calculateCaratsTable },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "add-to-cart-btn",
                      attrs: { variant: "primary" },
                      on: { click: _vm.addToBasket }
                    },
                    [_vm._v(_vm._s(_vm.$t("addToBasket")))]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", [
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("carats-table.sku")))]),
                _c("th", [_vm._v(_vm._s(_vm.$t("carats-table.carat")))]),
                _c("th", [_vm._v(_vm._s(_vm.$t("carats-table.price")))]),
                _c("th", [_vm._v(_vm._s(_vm.$t("carats-table.quantity")))])
              ]),
              _c(
                "tbody",
                _vm._l(_vm.carats, function(item) {
                  return _c("tr", { key: item.sku }, [
                    _c("td", { staticClass: "sku" }, [
                      _vm._v(_vm._s(item.sku))
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          (item.placeholders.tctmix.replace(/,/, ".") > 0
                            ? item.placeholders.tctmix
                            : item.placeholders.tctpst) +
                            " " +
                            _vm.$t("ct")
                        )
                      )
                    ]),
                    _c("td", { staticClass: "price" }, [
                      _vm._v(_vm._s(item.price) + " €")
                    ]),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: item.quantity,
                            expression: "item.quantity"
                          }
                        ],
                        staticClass: "input-pieces",
                        attrs: { type: "number", min: "0" },
                        domProps: { value: item.quantity },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(item, "quantity", $event.target.value)
                            },
                            function($event) {
                              return _vm.validatePositiveNumber(item)
                            }
                          ]
                        }
                      })
                    ])
                  ])
                }),
                0
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }